import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import FormList from './components/FormList';
import FormRenderer from './components/FormRenderer';
import MySubmissions from './components/MySubmissions';
import PrivateRoute from './components/PrivateRoute';
import authService from './services/authService';
import './styles/main.scss';

function App() {
  const handleLoginSuccess = () => {
    window.location.href = '/forms';
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={
              authService.isAuthenticated() 
                ? <Navigate to="/forms" replace /> 
                : <Login onLoginSuccess={handleLoginSuccess} />
            } 
          />
          
          <Route 
            path="/forms" 
            element={
              <PrivateRoute>
                <FormList />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/form/:formId" 
            element={
              <PrivateRoute>
                <FormRenderer />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/my-submissions" 
            element={
              <PrivateRoute>
                <MySubmissions />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/" 
            element={<Navigate to="/forms" replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
